import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Login } from './pages/Login/Login'
import ChangePassword from './pages/ChangePassword/ChangePassword'
import { Dashboard } from './pages/Dashboard/Dashboard'
import { Companies } from './pages/Companies/Companies'
import { Users } from './pages/Users/Users'
import { Partnerships } from './pages/Partnerships/Partnerships'
import { Transactions } from './pages/Transactions/Transactions'
import { UsageEvents } from './pages/UsageEvents/UsageEvents'
import { UsageLogs } from './pages/UsageLogs/UsageLogs'
import { Apportionments } from './pages/Apportionments/Apportionments'
import { ServiceStatus } from './pages/ServiceStatus/ServiceStatus'
import { Reports } from './pages/Reports/Reports'
import { ReportDetail } from './pages/Reports/ReportDetail'
import { Analytics } from './pages/Analytics/Analytics'
import { PortalContent } from './pages/PortalContent/PortalContent'
import ApiDevPanel from './components/ApiDevPanel/ApiDevPanel'
import styles from './App.module.css'

function App() {
  return (
    <Router>
      <AuthProvider>
        <ApiDevPanel />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies"
            element={
              <ProtectedRoute>
                <Companies />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partnerships"
            element={
              <ProtectedRoute>
                <Partnerships />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <Transactions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usage-events"
            element={
              <ProtectedRoute>
                <UsageEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usage-logs"
            element={
              <ProtectedRoute>
                <UsageLogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apportionments"
            element={
              <ProtectedRoute>
                <Apportionments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service-status"
            element={
              <ProtectedRoute>
                <ServiceStatus />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/:reportId"
            element={
              <ProtectedRoute>
                <ReportDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/portal-content"
            element={
              <ProtectedRoute>
                <PortalContent />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App
